import React from "react"
import classNames from "classnames";

import { addIndex, map } from "ramda";

import styles from "./styles.module.scss";
// import colors from "../../styles/colors.module.scss";
// import box from "../../styles/box.module.scss";

const AiringTable = ({airings, headerTitles={}}) => (
  <table className={classNames("uk-table", styles.table)}>
    <thead className={styles.header}>
      <tr>
        <td className={classNames("text-align-center uk-text-middle uk-text-bold")}>#</td>
        <td className={classNames("text-align-left uk-text-middle uk-text-bold")}>{ headerTitles.entityType || "Brand" }</td>
        <td className={classNames("text-align-left uk-text-middle")}>Creative<br />Description</td>
        <td className={classNames(styles.score, "text-align-center uk-text-middle uk-text-bold")}>Search<br />Engagement<br/>Index</td>
        <td className={classNames("text-align-center uk-text-middle")}>Airing<br />Quarter</td>
        <td className={classNames("text-align-center uk-text-middle")}>Air Time<br />(ET)</td>
        <td className={classNames("text-align-center uk-text-middle")}>Duration<br />(seconds)</td>
      </tr>
    </thead>
    <tbody className={styles.body}>
      {
        addIndex(map)((airing, i) => (
          <tr key={i} className={classNames(styles.row, i % 2 === 0 ? styles.light : styles.dark)}>
            <td className={classNames("text-align-center uk-text-middle uk-text-bold")}>{i + 1}</td>
            <td className={classNames("text-align-left uk-text-middle uk-text-bold")}>{airing.brand}</td>
            <td className={classNames("text-align-left uk-text-middle")}>{airing.description}</td>
            <td className={classNames(styles.score, "text-align-center uk-text-middle uk-text-bold")}>{airing.score}</td>
            <td className={classNames(styles.quarter, "text-align-center uk-text-middle")}>{airing.quarter}</td>
            <td className={classNames(styles.time, "text-align-center uk-text-middle")}>{airing.time}</td>
            <td className={classNames("text-align-center uk-text-middle")}>{airing.duration}</td>
          </tr>
        ), airings)
      }
    </tbody>
  </table>
);

export default AiringTable;
